export function safeStorageGet(key) {
  try {
    if (typeof window === 'undefined') return null
    if (!window.localStorage) return null
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeStorageSet(key, value) {
  try {
    if (typeof window === 'undefined') return
    if (!window.localStorage) return
    window.localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

export function safeStorageRemove(key) {
  try {
    if (typeof window === 'undefined') return
    if (!window.localStorage) return
    window.localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
